import {OnDestroy, OnInit} from '@angular/core';
import {AppStatus} from '../../@models/app-status';
import {StatusListener} from '../../status-listener';
import {TimeGuard}      from '../../../../../Shared/shared/utils/time-guard';
import {AppStatusFun}   from '../../@models/app-status.fun';
import {AppService} from '../../services/app.service';

export class ServingPageBase extends StatusListener implements OnInit, OnDestroy {

	width: number = 0;
	servingTime: number;
	isServed: boolean = false;
	timeGuard: TimeGuard = new TimeGuard();

	constructor(app: AppService) {
		super(app);
	}

	async ngOnInit() {
		await super.ngOnInit();
		// Get serving time for this product
		const defServingTime = 35;
		this.servingTime = defServingTime;

		const status = this.app.getStatus();
		const order = status.deviceStatus.VendingStatus.Order;

		if (!order) {
			return false;
		}

		if (order) {
			for (let cell of order.Items) {
				this.servingTime += (cell.Product.ServingTime && cell.Product.ServingTime > 0 ? cell.Product.ServingTime : defServingTime);
			}
		}

		let timeMs = 0;
		let stepMs = 50;
		let timer = setInterval(() => {
			timeMs += stepMs;
			if (timeMs > this.servingTime * 1000) {
				clearInterval(timer);
			} else {
				this.width = Math.round(timeMs / (this.servingTime * 1000) * 100);
			}
		}, stepMs);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		if (false === this.isServed && AppStatusFun.getVmcState(status) === 'Served') {
			// Served right now
			this.isServed = true;
		}
	}

}
